/**
 * Controller: ProgramsRemoveModal
 */
angular.module('acme.view.application.programs.removeModal.controllers', [])
.controller('ProgramsRemoveModalController', [ '$scope', '$uibModalInstance', 'currentEvent', 'SoldQuantity', 'emailSetting', function ($scope, $uibModalInstance, currentEvent, SoldQuantity, emailSetting) {

    $scope.errors = [];

    $scope.model = {};

    $scope.init = function() {
      this.model = currentEvent;
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.hasSold = function() {
      return (SoldQuantity && SoldQuantity > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);